(() => {
var $89cf5368902f0282$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ var $74148a4d3a24de22$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ var $a497a983a0dcb4fe$exports = {};
function $a497a983a0dcb4fe$var$get(obj, path, defaultValue) {
    const keys = Array.isArray(path) ? path : path.split(".");
    let result = obj;
    for (const key of keys){
        result = result[key];
        if (result === undefined) return defaultValue;
    }
    return result;
}
function $a497a983a0dcb4fe$var$has(obj, path) {
    const keys = Array.isArray(path) ? path : path.split(".");
    let result = obj;
    for (const key of keys){
        /* eslint-disable no-prototype-builtins */ if (!result?.hasOwnProperty(key)) return false;
        result = result[key];
    }
    return true;
}
$a497a983a0dcb4fe$exports = {
    get: $a497a983a0dcb4fe$var$get,
    has: $a497a983a0dcb4fe$var$has
};


var $a9db500a8fedd32d$exports = {};
$a9db500a8fedd32d$exports = JSON.parse('{"version":"3.0.1"}');


var $74148a4d3a24de22$require$version = $a9db500a8fedd32d$exports.version;
var $aad298d30752c6a6$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ var $083a6b267f0e4609$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ $083a6b267f0e4609$exports = function(data, constraints) {
    // Go through all constraints and find one which does not match the data
    const foundObjection = Object.keys(constraints).find((key)=>{
        const type = constraints[key].type;
        const supportedValues = key && constraints[key].values;
        const mandatory = !constraints[key].optional;
        const value = data[key];
        const valueType = typeof value;
        const incorrectType = type && valueType !== type;
        const noMatchForSupportedValues = supportedValues && !supportedValues.includes(value);
        if (mandatory) return !value || incorrectType || noMatchForSupportedValues;
        else return value && (incorrectType || noMatchForSupportedValues);
    });
    // If no objections found then data matches contraints
    return typeof foundObjection === "undefined";
};


var $196c54e0717366f7$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ /**
 * Constraints for each type of the item configuration.
 */ const $196c54e0717366f7$var$itemConstraints = {
    event: {
        event: {
            type: "string"
        },
        eventInfo: {
            optional: true
        }
    },
    listenerOn: {
        on: {
            type: "string"
        },
        handler: {
            type: "function"
        },
        scope: {
            type: "string",
            values: [
                "past",
                "future",
                "all"
            ],
            optional: true
        },
        path: {
            type: "string",
            optional: true
        }
    },
    listenerOff: {
        off: {
            type: "string"
        },
        handler: {
            type: "function",
            optional: true
        },
        scope: {
            type: "string",
            values: [
                "past",
                "future",
                "all"
            ],
            optional: true
        },
        path: {
            type: "string",
            optional: true
        }
    }
};
$196c54e0717366f7$exports = $196c54e0717366f7$var$itemConstraints;


var $446225c82cc393af$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ const $446225c82cc393af$var$CONSTANTS = {
    /**
   * @typedef {String} ItemType
   **/ /**
   * Enumeration of data layer item types.
   *
   * @enum {ItemType}
   * @readonly
   */ itemType: {
        /** Represents an item of type data */ DATA: "data",
        /** Represents an item of type function */ FCTN: "fctn",
        /** Represents an item of type event */ EVENT: "event",
        /** Represents an item of type listener on */ LISTENER_ON: "listenerOn",
        /** Represents an item of type listener off */ LISTENER_OFF: "listenerOff"
    },
    /**
   * @typedef {String} DataLayerEvent
   **/ /**
   * Enumeration of data layer events.
   *
   * @enum {DataLayerEvent}
   * @readonly
   */ dataLayerEvent: {
        /** Represents an event triggered for any change in the data layer state */ CHANGE: "adobeDataLayer:change",
        /** Represents an event triggered for any event push to the data layer */ EVENT: "adobeDataLayer:event"
    },
    /**
   * @typedef {String} ListenerScope
   **/ /**
   * Enumeration of listener scopes.
   *
   * @enum {ListenerScope}
   * @readonly
   */ listenerScope: {
        /** Past events only */ PAST: "past",
        /** Future events only */ FUTURE: "future",
        /** All events, past and future */ ALL: "all"
    }
};
$446225c82cc393af$exports = $446225c82cc393af$var$CONSTANTS;


const $aad298d30752c6a6$var$isEmpty = (obj)=>[
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
function $aad298d30752c6a6$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
/**
 * Constructs a data layer item.
 *
 * @param {ItemConfig} itemConfig The data layer item configuration.
 * @param {Number} index The item index in the array of existing items.
 */ $aad298d30752c6a6$exports = function(itemConfig, index) {
    const _config = itemConfig;
    const _index = index;
    const _type = getType();
    const _data = getData();
    const _valid = !!_type;
    function getType() {
        return Object.keys($196c54e0717366f7$exports).find((key)=>$083a6b267f0e4609$exports(_config, $196c54e0717366f7$exports[key])) || typeof _config === "function" && $446225c82cc393af$exports.itemType.FCTN || $aad298d30752c6a6$var$isPlainObject(_config) && $446225c82cc393af$exports.itemType.DATA;
    }
    function getData() {
        const data = Object.keys(_config).filter((key)=>!Object.keys($196c54e0717366f7$exports.event).includes(key)).reduce((obj, key)=>{
            obj[key] = _config[key];
            return obj;
        }, {});
        if (!$aad298d30752c6a6$var$isEmpty(data)) return data;
    }
    return {
        /**
     * Returns the item configuration.
     *
     * @returns {ItemConfig} The item configuration.
     */ config: _config,
        /**
     * Returns the item type.
     *
     * @returns {itemType} The item type.
     */ type: _type,
        /**
     * Returns the item data.
     *
     * @returns {DataConfig} The item data.
     */ data: _data,
        /**
     * Indicates whether the item is valid.
     *
     * @returns {Boolean} true if the item is valid, false otherwise.
     */ valid: _valid,
        /**
     * Returns the index of the item in the array of existing items (added with the standard Array.prototype.push())
     *
     * @returns {Number} The index of the item in the array of existing items if it exists, -1 otherwise.
     */ index: _index
    };
};


var $baa3abaa0e0ec31e$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ 
/**
 * Constructs a data layer listener.
 *
 * @param {Item} item The item from which to construct the listener.
 */ $baa3abaa0e0ec31e$exports = function(item) {
    const _event = item.config.on || item.config.off;
    const _handler = item.config.handler || null;
    const _scope = item.config.scope || item.config.on && $446225c82cc393af$exports.listenerScope.ALL || null;
    const _path = item.config.path || null;
    return {
        /**
     * Returns the listener event name.
     *
     * @returns {String} The listener event name.
     */ event: _event,
        /**
     * Returns the listener handler.
     *
     * @returns {(Function|null)} The listener handler.
     */ handler: _handler,
        /**
     * Returns the listener scope.
     *
     * @returns {(String|null)} The listener scope.
     */ scope: _scope,
        /**
     * Returns the listener path.
     *
     * @returns {(String|null)} The listener path.
     */ path: _path
    };
};


var $2745f882509d60f5$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ var $20b0c66b40d81262$exports = {};
function $20b0c66b40d81262$var$mergeWith(target, source, customizer) {
    if (!source || !target) return;
    Object.keys(source).forEach((key)=>{
        let newValue = customizer ? customizer(target[key], source[key], key, target) : undefined;
        if (newValue === undefined) {
            if (source[key] === Object(source[key]) && key in target && !Array.isArray(source[key])) newValue = $20b0c66b40d81262$var$mergeWith(target[key], source[key], customizer);
            else newValue = source[key];
        }
        target[key] = newValue;
    });
    return target;
}
function $20b0c66b40d81262$var$cloneDeepWith(target, customizer) {
    let newTarget = customizer ? customizer(target) : undefined;
    if (newTarget === undefined) {
        if (target === Object(target) && !Array.isArray(target)) {
            newTarget = {};
            const keys = Object.keys(target);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                newTarget[key] = $20b0c66b40d81262$var$cloneDeepWith(target[key], customizer);
            }
        }
        newTarget = structuredClone(target);
    }
    return newTarget;
}
$20b0c66b40d81262$exports = {
    mergeWith: $20b0c66b40d81262$var$mergeWith,
    cloneDeepWith: $20b0c66b40d81262$var$cloneDeepWith
};



var $aed5a7be42aa6003$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ 

var $37e37d5d9a9bb306$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ 
/**
  * Checks if the object contains an ancestor that is set to null or undefined.
  *
  * @param {Object} object The object to check.
  * @param {String} path The path to check.
  * @returns {Boolean} true if the object contains an ancestor that is set to null or undefined, false otherwise.
  * @private
  */ $37e37d5d9a9bb306$exports = function(object, path) {
    let ancestorPath = path.substring(0, path.lastIndexOf("."));
    while(ancestorPath){
        if ((0, $a497a983a0dcb4fe$exports.has)(object, ancestorPath)) {
            const ancestorValue = (0, $a497a983a0dcb4fe$exports.get)(object, ancestorPath);
            if (ancestorValue === null || ancestorValue === undefined) return true;
        }
        ancestorPath = ancestorPath.substring(0, ancestorPath.lastIndexOf("."));
    }
    return false;
};


/**
 * Checks if the listener matches the item.
 *
 * @param {Listener} listener The listener.
 * @param {Item} item The item.
 * @returns {Boolean} true if listener matches the item, false otherwise.
 */ function $aed5a7be42aa6003$var$listenerMatch(listener, item) {
    const event = listener.event;
    const itemConfig = item.config;
    let matches = false;
    if (item.type === $446225c82cc393af$exports.itemType.DATA) {
        if (event === $446225c82cc393af$exports.dataLayerEvent.CHANGE) matches = $aed5a7be42aa6003$var$selectorMatches(listener, item);
    } else if (item.type === $446225c82cc393af$exports.itemType.EVENT) {
        if (event === $446225c82cc393af$exports.dataLayerEvent.EVENT || event === itemConfig.event) matches = $aed5a7be42aa6003$var$selectorMatches(listener, item);
        if (item.data && event === $446225c82cc393af$exports.dataLayerEvent.CHANGE) matches = $aed5a7be42aa6003$var$selectorMatches(listener, item);
    }
    return matches;
}
/**
 * Checks if a listener has a selector that points to an object in the data payload of an item.
 *
 * @param {Listener} listener The listener to extract the selector from.
 * @param {Item} item The item.
 * @returns {Boolean} true if a selector is not provided or if the given selector is matching, false otherwise.
 * @private
 */ function $aed5a7be42aa6003$var$selectorMatches(listener, item) {
    if (item.data && listener.path) return (0, $a497a983a0dcb4fe$exports.has)(item.data, listener.path) || $37e37d5d9a9bb306$exports(item.data, listener.path);
    return true;
}
$aed5a7be42aa6003$exports = $aed5a7be42aa6003$var$listenerMatch;


var $0df9287d847fce76$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ $0df9287d847fce76$exports = function(listeners, listener) {
    const event = listener.event;
    if (Object.prototype.hasOwnProperty.call(listeners, event)) for (const [index, registeredListener] of listeners[event].entries()){
        if (registeredListener.handler === listener.handler) return index;
    }
    return -1;
};


/**
 * Creates a listener manager.
 *
 * @param {Manager} dataLayerManager The data layer manager.
 * @returns {ListenerManager} A listener manager.
 */ $2745f882509d60f5$exports = function(dataLayerManager) {
    const _listeners = {};
    const _dataLayerManager = dataLayerManager;
    /**
   * Find index of listener in listeners object.
   */ const _indexOfListener = $0df9287d847fce76$exports.bind(null, _listeners);
    const ListenerManager = {
        /**
     * Registers a listener.
     *
     * @function
     * @param {Listener} listener The listener to register.
     * @returns {Boolean} true if the listener was registered, false otherwise.
     */ register: function(listener) {
            const event = listener.event;
            if (Object.prototype.hasOwnProperty.call(_listeners, event)) {
                if (_indexOfListener(listener) === -1) {
                    _listeners[listener.event].push(listener);
                    return true;
                }
            } else {
                _listeners[listener.event] = [
                    listener
                ];
                return true;
            }
            return false;
        },
        /**
     * Unregisters a listener.
     *
     * @function
     * @param {Listener} listener The listener to unregister.
     */ unregister: function(listener) {
            const event = listener.event;
            if (Object.prototype.hasOwnProperty.call(_listeners, event)) {
                if (!(listener.handler || listener.scope || listener.path)) _listeners[event] = [];
                else {
                    const index = _indexOfListener(listener);
                    if (index > -1) _listeners[event].splice(index, 1);
                }
            }
        },
        /**
     * Triggers listeners related to the passed item.
     *
     * @function
     * @param {Item} item Item to trigger listener for.
     */ triggerListeners: function(item) {
            const triggeredEvents = _getTriggeredEvents(item);
            triggeredEvents.forEach(function(event) {
                if (Object.prototype.hasOwnProperty.call(_listeners, event)) for (const listener of _listeners[event])_callHandler(listener, item);
            });
        },
        /**
     * Triggers a single listener on the passed item.
     *
     * @function
     * @param {Listener} listener Listener to call.
     * @param {Item} item Item to call the listener with.
     */ triggerListener: function(listener, item) {
            _callHandler(listener, item);
        }
    };
    /**
   * Calls the listener handler on the item if a match is found.
   *
   * @param {Listener} listener The listener.
   * @param {Item} item The item.
   * @private
   */ function _callHandler(listener, item) {
        if ($aed5a7be42aa6003$exports(listener, item)) {
            const callbackArgs = [
                (0, $20b0c66b40d81262$exports.cloneDeepWith)(item.config)
            ];
            listener.handler.apply(_dataLayerManager.getDataLayer(), callbackArgs);
        }
    }
    /**
   * Returns the names of the events that are triggered for this item.
   *
   * @param {Item} item The item.
   * @returns {Array<String>} The names of the events that are triggered for this item.
   * @private
   */ function _getTriggeredEvents(item) {
        const triggeredEvents = [];
        switch(item.type){
            case $446225c82cc393af$exports.itemType.DATA:
                triggeredEvents.push($446225c82cc393af$exports.dataLayerEvent.CHANGE);
                break;
            case $446225c82cc393af$exports.itemType.EVENT:
                triggeredEvents.push($446225c82cc393af$exports.dataLayerEvent.EVENT);
                if (item.data) triggeredEvents.push($446225c82cc393af$exports.dataLayerEvent.CHANGE);
                if (item.config.event !== $446225c82cc393af$exports.dataLayerEvent.CHANGE) triggeredEvents.push(item.config.event);
                break;
        }
        return triggeredEvents;
    }
    return ListenerManager;
};



var $674a2637d63bdaa3$exports = {};
/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/ 
var $674a2637d63bdaa3$require$cloneDeepWith = $20b0c66b40d81262$exports.cloneDeepWith;
var $674a2637d63bdaa3$require$mergeWith = $20b0c66b40d81262$exports.mergeWith;
/**
 * Merges the source into the object and sets objects as 'undefined' if they are 'undefined' in the source object.
 *
 * @param {Object} object The object into which to merge.
 * @param {Object} source The source to merge with.
 * @returns {Object} The object into which source was merged in.
 */ $674a2637d63bdaa3$exports = function(object, source) {
    const makeOmittingCloneDeepCustomizer = function(predicate) {
        return function omittingCloneDeepCustomizer(value) {
            if (value === Object(value)) {
                if (Array.isArray(value)) return value.filter((item)=>!predicate(item)).map((item)=>$674a2637d63bdaa3$require$cloneDeepWith(item, omittingCloneDeepCustomizer));
                const clone = {};
                for (const subKey of Object.keys(value))if (!predicate(value[subKey])) clone[subKey] = $674a2637d63bdaa3$require$cloneDeepWith(value[subKey], omittingCloneDeepCustomizer);
                return clone;
            }
            return undefined;
        };
    };
    const customizer = function(_, srcValue) {
        if (typeof srcValue === "undefined" || srcValue === null) return null;
    };
    const omitDeep = function(value, predicate = (val)=>!val) {
        return $674a2637d63bdaa3$require$cloneDeepWith(value, makeOmittingCloneDeepCustomizer(predicate));
    };
    $674a2637d63bdaa3$require$mergeWith(object, source, customizer);
    // Remove null or undefined objects
    object = omitDeep(object, (v)=>v === null || v === undefined);
    return object;
};


/**
 * Manager
 *
 * @class Manager
 * @classdesc Data Layer manager that augments the passed data layer array and handles eventing.
 * @param {Object} config The Data Layer manager configuration.
 */ $74148a4d3a24de22$exports = function(config) {
    const _config = config || {};
    let _dataLayer = [];
    let _preLoadedItems = [];
    let _state = {};
    let _listenerManager;
    const DataLayerManager = {
        getState: function() {
            return _state;
        },
        getDataLayer: function() {
            return _dataLayer;
        }
    };
    _initialize();
    _augment();
    _processItems();
    /**
   * Initializes the data layer.
   *
   * @private
   */ function _initialize() {
        if (!Array.isArray(_config.dataLayer)) _config.dataLayer = [];
        // Remove preloaded items from the data layer array and add those to the array of preloaded items
        _preLoadedItems = _config.dataLayer.splice(0, _config.dataLayer.length);
        _dataLayer = _config.dataLayer;
        _dataLayer.version = $74148a4d3a24de22$require$version;
        _state = {};
        _listenerManager = $2745f882509d60f5$exports(DataLayerManager);
    }
    /**
   * Updates the state with the item.
   *
   * @param {Item} item The item.
   * @private
   */ function _updateState(item) {
        _state = $674a2637d63bdaa3$exports(_state, item.data);
    }
    /**
   * Augments the data layer Array Object, overriding: push() and adding getState(), addEventListener and removeEventListener.
   *
   * @private
   */ function _augment() {
        /**
     * Pushes one or more items to the data layer.
     *
     * @param {...ItemConfig} args The items to add to the data layer.
     * @returns {Number} The length of the data layer following push.
     */ _dataLayer.push = function(...args) {
            const pushArguments = args;
            const filteredArguments = args;
            Object.keys(pushArguments).forEach(function(key) {
                const itemConfig = pushArguments[key];
                const item = $aad298d30752c6a6$exports(itemConfig);
                if (!item.valid) {
                    _logInvalidItemError(item);
                    delete filteredArguments[key];
                }
                switch(item.type){
                    case $446225c82cc393af$exports.itemType.DATA:
                    case $446225c82cc393af$exports.itemType.EVENT:
                        _processItem(item);
                        break;
                    case $446225c82cc393af$exports.itemType.FCTN:
                        delete filteredArguments[key];
                        _processItem(item);
                        break;
                    case $446225c82cc393af$exports.itemType.LISTENER_ON:
                    case $446225c82cc393af$exports.itemType.LISTENER_OFF:
                        delete filteredArguments[key];
                }
            });
            if (filteredArguments[0]) return Array.prototype.push.apply(this, filteredArguments);
        };
        /**
     * Returns a deep copy of the data layer state or of the object defined by the path.
     *
     * @param {Array|String} path The path of the property to get.
     * @returns {*} Returns a deep copy of the resolved value if a path is passed, a deep copy of the data layer state otherwise.
     */ _dataLayer.getState = function(path) {
            if (path) return (0, $a497a983a0dcb4fe$exports.get)(structuredClone(_state), path);
            return structuredClone(_state);
        };
        /**
     * Event listener callback.
     *
     * @callback eventListenerCallback A function that is called when the event of the specified type occurs.
     * @this {DataLayer}
     * @param {Object} event The event object pushed to the data layer that triggered the callback.
     */ /**
     * Sets up a function that will be called whenever the specified event is triggered.
     *
     * @param {String} type A case-sensitive string representing the event type to listen for.
     * @param {eventListenerCallback} callback A function that is called when the event of the specified type occurs.
     * @param {Object} [options] Optional characteristics of the event listener.
     * @param {String} [options.path] The path in the state object to filter the listening to.
     * @param {('past'|'future'|'all')} [options.scope] The timing to filter the listening to:
     *      - {String} past The listener is triggered for past events only.
     *      - {String} future The listener is triggered for future events only.
     *      - {String} all The listener is triggered for both past and future events (default value).
     */ _dataLayer.addEventListener = function(type, callback, options) {
            const eventListenerItem = $aad298d30752c6a6$exports({
                on: type,
                handler: callback,
                scope: options && options.scope,
                path: options && options.path
            });
            _processItem(eventListenerItem);
        };
        /**
     * Removes an event listener previously registered with addEventListener().
     *
     * @param {String} type A case-sensitive string representing the event type to listen for.
     * @param {Function} [listener] Optional function that is to be removed.
     */ _dataLayer.removeEventListener = function(type, listener) {
            const eventListenerItem = $aad298d30752c6a6$exports({
                off: type,
                handler: listener
            });
            _processItem(eventListenerItem);
        };
    }
    /**
   * Processes all items that already exist on the stack.
   *
   * @private
   */ function _processItems() {
        for(let i = 0; i < _preLoadedItems.length; i++)_dataLayer.push(_preLoadedItems[i]);
    }
    /**
   * Processes an item pushed to the stack.
   *
   * @param {Item} item The item to process.
   * @private
   */ function _processItem(item) {
        if (!item.valid) {
            _logInvalidItemError(item);
            return;
        }
        /**
     * Returns all items before the provided one.
     *
     * @param {Item} item The item.
     * @returns {Array<Item>} The items before.
     * @private
     */ function _getBefore(item) {
            if (!(_dataLayer.length === 0 || item.index > _dataLayer.length - 1)) return _dataLayer.slice(0, item.index).map((itemConfig)=>$aad298d30752c6a6$exports(itemConfig));
            return [];
        }
        const typeProcessors = {
            data: function(item) {
                _updateState(item);
                _listenerManager.triggerListeners(item);
            },
            fctn: function(item) {
                item.config.call(_dataLayer, _dataLayer);
            },
            event: function(item) {
                if (item.data) _updateState(item);
                _listenerManager.triggerListeners(item);
            },
            listenerOn: function(item) {
                const listener = $baa3abaa0e0ec31e$exports(item);
                switch(listener.scope){
                    case $446225c82cc393af$exports.listenerScope.PAST:
                        for (const registeredItem of _getBefore(item))_listenerManager.triggerListener(listener, registeredItem);
                        break;
                    case $446225c82cc393af$exports.listenerScope.FUTURE:
                        _listenerManager.register(listener);
                        break;
                    case $446225c82cc393af$exports.listenerScope.ALL:
                        {
                            const registered = _listenerManager.register(listener);
                            if (registered) for (const registeredItem of _getBefore(item))_listenerManager.triggerListener(listener, registeredItem);
                        }
                }
            },
            listenerOff: function(item) {
                _listenerManager.unregister($baa3abaa0e0ec31e$exports(item));
            }
        };
        typeProcessors[item.type](item);
    }
    /**
   * Logs error for invalid item pushed to the data layer.
   *
   * @param {Item} item The invalid item.
   * @private
   */ function _logInvalidItemError(item) {
        const message = "The following item cannot be handled by the data layer because it does not have a valid format: " + JSON.stringify(item.config);
        console.error(message);
    }
    return DataLayerManager;
};


/**
 * Data Layer.
 *
 * @type {Object}
 */ const $89cf5368902f0282$var$DataLayer = {
    Manager: $74148a4d3a24de22$exports
};
window.adobeDataLayer = window.adobeDataLayer || [];
// If data layer has already been initialized, do not re-initialize.
if (window.adobeDataLayer.version) console.warn(`Adobe Client Data Layer v${window.adobeDataLayer.version} has already been imported/initialized on this page. You may be erroneously loading it a second time.`);
else $89cf5368902f0282$var$DataLayer.Manager({
    dataLayer: window.adobeDataLayer
});
/**
 * @typedef  {Object} ListenerOnConfig
 * @property {String} on Name of the event to bind to.
 * @property {String} [path] Object key in the state to bind to.
 * @property {ListenerScope} [scope] Scope of the listener.
 * @property {Function} handler Handler to execute when the bound event is triggered.
 */ /**
 * @typedef  {Object} ListenerOffConfig
 * @property {String} off Name of the event to unbind.
 * @property {String} [path] Object key in the state to bind to.
 * @property {ListenerScope} [scope] Scope of the listener.
 * @property {Function} [handler] Handler for a previously attached event to unbind.
 */ /**
 * @typedef {Object} DataConfig
 * @property {Object} data Data to be updated in the state.
 */ /**
 * @typedef {Object} EventConfig
 * @property {String} event Name of the event.
 * @property {Object} [eventInfo] Additional information to pass to the event handler.
 * @property {DataConfig.data} [data] Data to be updated in the state.
 */ /**
 * @typedef {DataConfig | EventConfig | ListenerOnConfig | ListenerOffConfig} ItemConfig
 */ /**
 * Triggered when there is change in the data layer state.
 *
 * @event DataLayerEvent.CHANGE
 * @type {Object}
 * @property {Object} data Data pushed that caused a change in the data layer state.
 */ /**
 * Triggered when an event is pushed to the data layer.
 *
 * @event DataLayerEvent.EVENT
 * @type {Object}
 * @property {String} name Name of the committed event.
 * @property {Object} eventInfo Additional information passed with the committed event.
 * @property {Object} data Data that was pushed alongside the event.
 */ /**
 * Triggered when an arbitrary event is pushed to the data layer.
 *
 * @event <custom>
 * @type {Object}
 * @property {String} name Name of the committed event.
 * @property {Object} eventInfo Additional information passed with the committed event.
 * @property {Object} data Data that was pushed alongside the event.
 */ $89cf5368902f0282$exports = $89cf5368902f0282$var$DataLayer;

})();
//# sourceMappingURL=adobe-client-data-layer.min.js.map
